import React from "react";
import { Tick1, X } from "../../icons";
import { PlaceholderIcon, PlaceholderText } from "../../InputMol.styled";
function Placeholder(_ref) {
  var placeholder = _ref.placeholder,
    hasValue = _ref.hasValue,
    hasError = _ref.hasError,
    hasSuccess = _ref.hasSuccess;
  var placeholderTextJsx = /*#__PURE__*/React.createElement(PlaceholderText, {
    $hasValue: hasValue,
    $hasError: hasError,
    $hasSuccess: hasSuccess
  }, placeholder);
  if (hasError) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, placeholderTextJsx, /*#__PURE__*/React.createElement(PlaceholderIcon, {
      icon: X,
      color: "error",
      sizeSpace: 1
    }));
  }
  if (hasSuccess) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, placeholderTextJsx, /*#__PURE__*/React.createElement(PlaceholderIcon, {
      icon: Tick1,
      color: "success",
      sizeSpace: 1
    }));
  }
  return placeholderTextJsx;
}
export default Placeholder;